import { Stack, Typography } from '@mui/material';
import type { UseFormReturn } from 'react-hook-form';
import { _ } from '/@/locale';
import { MuiSelect } from '/@/mui/select';

const DashboardSubheader = ({
    title,
    subtitle,
    form,
}: {
    title: string;
    subtitle: string;
    form?: UseFormReturn<{ year: number }>;
}) => {
    const year = form?.watch('year');
    return (
        <Stack direction='row' justifyContent='space-between' alignItems='start' spacing={1}>
            <Stack direction='column' spacing={1}>
                <Typography variant='h5' color='primary'>
                    {title}
                </Typography>
                <Typography variant='subtitle1' color='primary.mui.inactive'>
                    {subtitle}
                </Typography>
            </Stack>
            {form && (
                <Stack>
                    <MuiSelect
                        {...form?.register('year')}
                        onChange={(e) => form?.setValue('year', Number(e.target.value))}
                        type='number'
                        value={year}
                        inputLabel={_('Campaña')}
                        options={Array.from({ length: 5 }, (_, index) => ({
                            label:
                                (new Date().getFullYear() - index).toString() +
                                ' / ' +
                                (new Date().getFullYear() - index + 1),
                            value: (new Date().getFullYear() - index).toString(),
                        }))}
                        size='small'
                        data-testid='dashboard-sub-header-year-select'
                        sx={{
                            width: {
                                md: 200,
                            },
                        }}
                    />
                </Stack>
            )}
        </Stack>
    );
};

export default DashboardSubheader;
